































import Vue, { PropType } from 'vue';
import { Image } from '@/modules/image';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GImageForm',
  props: {
    owner: { type: String as PropType<string>, required: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string> },
    name: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
    multiple: { type: Boolean as PropType<boolean>, default: false },
    caution: { type: String as PropType<string>, default: null },
    withDescription: { type: Boolean as PropType<boolean>, default: false },
    value: { type: [Object, Array] as PropType<Image | Image[]>, default: null },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): Image | Image[] | null {
        return this.value;
      },
      set(val: Image | Image[] | null): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gImageFormProvider as any).validate();
    },
  },
});
